<div class="main">
  <app-menu></app-menu>
  <router-outlet></router-outlet>
</div>
